import {  TbPackageOff } from "react-icons/tb";
import { CardShimmer } from "components/shimmer/cardShimmer";
import {FaCartPlus, FaStar, FaTruck} from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useState } from "react";
import OrderNowModal from "models/orderNowModal";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
import { getCartItems, setCartItems } from "utils/cartStorage";
import { assetUrl } from "utils/api";
const CardDesign = ({ likeData, loading, error }) => {
  const [orderModalOpen, setOrderModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
    const { theme, language } = useSettings();
    const isDark = theme === "dark";
  if (loading) {
    return (
      <div className={`relative ${isDark?"bg-gray-100":"bg-white"} rounded mb-5 md:max-w-7xl mx-auto px-5 lg:px-8`}>
        <div className="py-5">
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {Array.from({ length: 10 }).map((_, index) => (
              <CardShimmer key={index} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="relative md:max-w-7xl mx-auto sm:px-4 2xl:px-0 lg:px-8 md:pb-4 pb-0">
      <div className="py-5 px-4 pb-5">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 2xl:grid-cols-5 md:gap-4 gap-2">
          {likeData?.length ? (
            likeData
              .slice()
              .reverse()
              .map((item, index) => {
                const isOutOfStock = item.stock === 0;
                // ✅ Split title and flashPrice per product
                const firstVariant = item.variants?.[0] || {};
                const firstImage = firstVariant.images?.[0]?.thumb || "";

                const selectedTitle = firstVariant.title || "-";
                const selectedPrice = firstVariant.flashPrice || 0;
                const selectedDiscount = firstVariant.discount || 0;
                const originalPrice = selectedDiscount || 0;
                const flashPrice = selectedPrice || 0;
                const freeVariantDelivery = firstVariant?.freeVariantDelivery;
                const discountPercent =
                  originalPrice > 0
                    ? Math.ceil(
                        ((originalPrice - flashPrice) / originalPrice) * 100,
                      )
                    : 0;
                return (
                    <div
                        className={`group relative mb-3 flex h-full flex-col overflow-hidden rounded-[18px] border border-slate-200 bg-white transition-all shadow-md duration-300  hover:shadow-[0_12px_26px_rgba(15,23,42,0.14)] ${
                            isOutOfStock ? "cursor-not-allowed opacity-45" : ""
                        }`}
                    >
                    {isOutOfStock && (
                      <div className="absolute inset-0 flex items-center justify-center z-20">
                        <div className="bg-red-600 text-white text-2xl font-bold px-3 py-2 rounded-lg shadow-lg">
                          Stock Out
                        </div>
                      </div>
                    )}

                    <a href={`/details/${item.catalogue}/${item.item_id}`} className="block">
                        <div className="relative flex aspect-[1/1.08] items-center justify-center overflow-hidden bg-white px-2 pt-6">
                            <img
                                src={assetUrl(firstImage)}
                                alt={selectedTitle}
                                loading={index < 4 ? "eager" : "lazy"}
                                fetchPriority={index === 0 ? "high" : "auto"}
                                decoding="async"
                                width={315}
                                height={460}
                                className="max-h-full w-full object-contain object-center transition-transform duration-500 group-hover:scale-105"
                                draggable={false}
                            />
                        <div className="absolute top-2 left-2">
                          {discountPercent > 0 && (
                            <div className="px-2 md:h-5 h-6 flex items-center justify-center rounded-xl bg-gradient-to-r from-orange-500 to-red-500 text-white font-semibold text-xs">
                              {discountPercent}% OFF
                            </div>
                          )}
                        </div>
                      </div>
                    </a>

                        <div className="flex flex-1 flex-col px-4 pb-3 pt-2">
                            <div className={`${isDark?"text-white":"text-gray-800"} text-center font-medium tracking-wide mb-1 text-sm leading-5 min-h-10 line-clamp-2`}>
                                {selectedTitle}
                            </div>
                            <div className="my-1 flex items-center justify-center gap-2">
                                <div className=" font-bold text-[#ff6a00] md:text-[18px] ">
                                    Tk. {selectedPrice}
                                </div>
                                {selectedDiscount > selectedPrice && (
                                    <div className="relative text-[12px] text-slate-400">
                                        <span>Tk. {selectedDiscount}</span>
                                        <div className="absolute left-0 right-0 top-1/2 h-px bg-slate-400" />
                                    </div>
                                )}
                            </div>
                            {freeVariantDelivery === 1 && (
                                <div
                                    className="flex items-center justify-center gap-1 px-3 py-1  rounded-full text-emerald-700 text-sm font-medium"
                                >
                                    <FaTruck className="text-sm" />
                                    {t("freeDeliveryBadge", language)}
                                </div>
                            )}
                            <div className="mb-1 flex items-center justify-center gap-1">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <FaStar
                                        key={star}
                                        className="text-yellow-400 text-sm"
                                    />
                                ))}
                                <span className="ml-1 text-sm font-medium text-gray-600">
                          (5.0)
                        </span>
                            </div>

                      {!isOutOfStock && (
                        <div className="flex gap-2 my-1 mt-auto px-1">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedItem(item);
                              setOrderModalOpen(true);
                            }}
                            className="mt-2 inline-flex w-full items-center justify-center rounded-full border border-[#ff6a00] bg-[#fff4ec] px-4 py-1 text-sm font-semibold text-[#ff6a00] transition-colors hover:bg-[#ff6a00] hover:text-white"
                          >
                              {t("order", language)}
                          </button>
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              // setDrawerOpen(true);

                              const existingItems = getCartItems();
                              const key = item.item_id || item.title;
                              const existingIndex = existingItems.findIndex(
                                (p) => (p.item_id || p.title) === key,
                              );
                              const firstVariant = item.variants?.[0] || {};
                              const colorArray = item.color
                                ? item.color.split(",").map((s) => s.trim())
                                : [];

                              const sizeArray = item.size
                                ? item.size.split(",").map((s) => s.trim())
                                : [];
                              const selectedColor = colorArray[0] || "";
                              const selectedSize = sizeArray[0] || "";
                              const selectedTitle = firstVariant.title || "";
                              const selectedPrice =
                                firstVariant.flashPrice || 0;

                              // ✅ FIRE TAG HERE
                              window.dataLayer = window.dataLayer || [];

                              window.dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                  currency: "BDT",
                                  value: selectedPrice,
                                  items: [
                                    {
                                      item_id: item.item_id,
                                      item_name: firstVariant.title,
                                      price: selectedPrice,
                                      item_category: item.catalogue_title,
                                      quantity: 1,
                                    },
                                  ],
                                },
                              });

                              console.log("add_to_cart fired");

                              if (existingIndex !== -1) {
                                existingItems[existingIndex] = {
                                  ...existingItems[existingIndex],
                                  quantity:
                                    (existingItems[existingIndex].quantity ||
                                      1) + 1,
                                  selectedColor,
                                  selectedSize,
                                  selectedTitle,
                                  selectedPrice,
                                };
                              } else {
                                existingItems.push({
                                  ...item,
                                  quantity: 1,
                                  selectedColor,
                                  selectedSize,
                                  selectedTitle,
                                  selectedPrice,
                                  selectedVariant: firstVariant,
                                });
                              }

                              setCartItems(existingItems);
                              toast.success(t("addedToCart", language));
                            }}
                            className=" text-darkBgColor py-1 mt-2"
                          >
                            <span className=" md:text-base text-sm">
                              <FaCartPlus />
                            </span>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
          ) : (
            <div className="col-span-full flex min-h-[320px] w-full items-center justify-center py-10 text-center text-backgroundColor">
              <div className="flex flex-col items-center justify-center">
                <TbPackageOff className="mb-5 h-40 w-40 animate-pulse text-backgroundColor" />
                <h3 className="mt-5 mb-2 text-base font-semibold sm:text-lg">
                    {t("noProductFound", language)}
                </h3>
              </div>
            </div>
          )}
        </div>
      </div>
      <OrderNowModal
        isOpen={orderModalOpen}
        item={selectedItem}
        onClose={() => setOrderModalOpen(false)}
      />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default CardDesign;
